import React from "react";
import { useTranslation } from "react-i18next";
import { WisgptContextTokenQueryVariables } from "@/shared/services/api/graphql/generated";
import { SummaryToolSection } from "@/shared/widgets/SummaryToolSection";
import { CustomTagsData } from "@/shared/widgets/MarkdownText/_components/MarkdownComponents";

interface ProfileSummarySectionProps
  extends Omit<React.HTMLProps<HTMLDivElement>, "scope"> {
  onDeleteSummary: () => void;
  onSaveSummary: (summary: string) => void;
  loading: boolean;
  deleting?: boolean;
  summaryContent?: string | null;
  isDisabled?: boolean;
  updatedAt?: string | null;
  contextLabel?: string;
  flowId: string;
  scope: WisgptContextTokenQueryVariables;
  tagsData?: CustomTagsData;
}

function ProfileSummarySection(props: ProfileSummarySectionProps) {
  const {
    onDeleteSummary,
    onSaveSummary,
    summaryContent,
    updatedAt,
    isDisabled,
    className,
    loading,
    deleting,
    flowId,
    scope,
    ...rest
  } = props;

  const { t } = useTranslation();

  return (
    <SummaryToolSection
      {...rest}
      onDeleteSummary={onDeleteSummary}
      onSaveSummary={onSaveSummary}
      summaryContent={summaryContent}
      loading={loading}
      deleting={deleting || false}
      flowId={flowId}
      scope={scope}
      title="Summary"
      subtitle={t("profile.summary_description", {
        contextLabel: props.contextLabel || "the profile",
      })}
    />
  );
}

export default ProfileSummarySection;
export { ProfileSummarySection };
